var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdsActiveAds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    fill: "#F9ED33"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.3332 49.668H23.6665C22.9832 49.668 22.4165 49.1013 22.4165 48.418C22.4165 47.7346 22.9832 47.168 23.6665 47.168H40.3332C41.0165 47.168 41.5832 47.7346 41.5832 48.418C41.5832 49.1013 41.0165 49.668 40.3332 49.668Z",
    fill: "#98911F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9165 22.1984L39.2499 26.9651C38.3665 27.5984 37.0999 27.2151 36.7165 26.1984L33.5665 17.7984C33.0332 16.3484 30.9832 16.3484 30.4499 17.7984L27.2832 26.1818C26.8999 27.2151 25.6499 27.5984 24.7665 26.9484L18.0999 22.1818C16.7665 21.2484 14.9999 22.5651 15.5499 24.1151L22.4832 43.5318C22.7165 44.1984 23.3499 44.6318 24.0499 44.6318H39.9332C40.6332 44.6318 41.2665 44.1818 41.4999 43.5318L48.4332 24.1151C48.9999 22.5651 47.2332 21.2484 45.9165 22.1984ZM36.1665 37.5818H27.8332C27.1499 37.5818 26.5832 37.0151 26.5832 36.3318C26.5832 35.6484 27.1499 35.0818 27.8332 35.0818H36.1665C36.8499 35.0818 37.4165 35.6484 37.4165 36.3318C37.4165 37.0151 36.8499 37.5818 36.1665 37.5818Z",
    fill: "#98911F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdsActiveAds);
export default __webpack_public_path__ + "static/media/ads-active-ads.c0b1e5f7b72de0b950743bb635b33ba4.svg";
export { ForwardRef as ReactComponent };